import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import "../../../dist/assets/stylesheets/css/newpatient.css";
import { createNewPatient } from "../../util/patientsApi";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { fetchPatients } from "../../store/patients-slice.js";
import { notificationActions } from "../../store/notification-slice";
import GlobalOverlayPortal from "../modals/GlobalOverlayPortal";

function AddNewPatientModal(props) {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      name: "",
      condition: "",
      notes: "",
      email: "",
      height: "",
      weight: "",
      gender: "",
      phone: "",
    },
  });

  const { values, setFieldValue } = formik;

  // CreatableSelect custom styles
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: "#ececec",
      border: "none",
      borderRadius: "0",
    }),
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    const token = localStorage.getItem("token");
    createNewPatient({ ...values, token: token })
      .then((res) => {
        props.handleClose();
        dispatch(fetchPatients());
        dispatch(
          notificationActions.setNotification({
            show: true,
            message: "Patient created successfully",
            status:'success'
          })
        );
      })
      .catch((e) =>{
        dispatch(
          notificationActions.setNotification({
            show: true,
            message: "Something wrong happened. Please try again.",
            status:'error'
          }))
      });
  };
  return (
    <GlobalOverlayPortal>
    <div id="patient-modal-container">
      <div id="patient-modal">
        <Icon onClick={props.handleClose} className='close-btn' icon="ic:round-close" />
        <div className="modal-header">
        <h3>
          Add new patient
        </h3>
        <span>Enter patient information.</span>

        </div>
        <form id="new-patient-form" onSubmit={handleSubmit}>
          <div className="form-group span3">
            <label required>Full Name </label>
            <input
              required
              onChange={(e) => setFieldValue("name", e.target.value)}
              className="new-patient-input"
            />
          </div>
          <div className="form-group">
            <label>Gender </label>
            <input
              onChange={(e) => setFieldValue("gender", e.target.value)}
              className="new-patient-input"
            />
          </div>
          <div className="form-group span2">
            <label required>Email </label>
            <input
              required
              onChange={(e) => setFieldValue("email", e.target.value)}
              className="new-patient-input"
            />
          </div>
          <div className="form-group span2">
            <label>Phone </label>
            <input
              onChange={(e) => setFieldValue("phone", e.target.value)}
              className="new-patient-input"
            />
          </div>

          <div className="form-group span2 ">
            <label>Height </label>
            <input
              onChange={(e) => setFieldValue("height", e.target.value)}
              className="new-patient-input"
            />
          </div>
          <div className="form-group span2">
            <label>Weight </label>
            <input
              onChange={(e) => setFieldValue("weight", e.target.value)}
              className="new-patient-input"
            />
          </div>
          <div className="form-group span4">
            <label>Condition </label>
            <input
              onChange={(e) => setFieldValue("condition", e.target.value)}
              className="new-patient-input"
            />
          </div>
          <div className="form-group span4">
            <label>Notes </label>
            <input
              onChange={(e) => setFieldValue("notes", e.target.value)}
              className="new-patient-input"
            />
          </div>
          <div id="add-patient-button-container" className="span4">
          <button id="cancel" onClick={props.handleClose}>
            Cancel
          </button>
          <button className="" type="submit" >
            Add Patient
          </button>
        </div>
        </form>
       
      </div>
    </div>
    </GlobalOverlayPortal>
  );
}

export default AddNewPatientModal;
